/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, ViewChild } from '@angular/core';
import { ImageService } from '../services/image.service';
import { FileUp } from '../models/FileUp';
import { Subscription, of, Subject, Observable, throwError } from 'rxjs';
import { ImageType } from '../models/imageType';
import { LookupDataService } from '../services/lookup-data.service';
import { BatchLog } from '../models/batchLog';
import { map, finalize, share } from 'rxjs/operators';
import { ColumnModel, IColumnModel, IRowModel } from 'table-editor';
import { getSecondsElapsedBetweenTwoDates, GetTimezoneCorrectedDate, onlyUniqueByKey } from 'starbase-launcher';
import { LUSource } from '../models/luSource';
import { AppInsightsService } from '../app-insights.service';
import { CallNumberModel } from '../models/callNumberModel';
import { SourceCallNoFilterComponent } from '../source-call-no-filter/source-call-no-filter.component';
import { BatchEdit } from '../models/batchEdit';
import { StarbaseNotificationObject, StarbaseNotificationSentiment, StarbaseNotificationService } from 'starbase-notification';

const LOADING_MESSAGE = 'Loading...';
const FILE_WAITING = 'Waiting';
const FILE_UPLOADING = 'Uploading...';
const FILE_CANCELED = 'Canceled';
const FILE_DONE = 'Done';
const FILE_ERROR = 'Error: ';

@Component({
  selector: 'app-batch-uploader',
  templateUrl: './batch-uploader.component.html',
  styleUrls: ['./batch-uploader.component.css']
})
export class BatchUploaderComponent implements OnInit, OnDestroy {

  @Input() showCard = false;
  @Input() maxFileSize = 31457280; // defaults to 30MB
  @Input() maxSimultaneousFiles = 100;
  @Output() refreshTrigger: EventEmitter<any> = new EventEmitter<any>();
  @Output() cardClosed: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('sourceCallNoFilter') sourceCallNoFilterCmp: SourceCallNoFilterComponent;


  public readonly LOADING_MESSAGE = LOADING_MESSAGE;
  public readonly FILE_WAITING = FILE_WAITING;
  public readonly FILE_UPLOADING = FILE_UPLOADING;
  public readonly FILE_CANCELED = FILE_CANCELED;
  public readonly FILE_DONE = FILE_DONE;
  public readonly FILE_ERROR = FILE_ERROR;

  private readonly defaultCardTitle = 'Upload ';
  private theLog: BatchLog = null;
  private queueCount: number;
  private isSaving = false;

  public cardTitle = this.defaultCardTitle + 'Images';
  public message = LOADING_MESSAGE;
  public messageBadgeClass = '';
  public messageIconClass = 'fa-info-circle text-info';
  public working = false;
  public step1Ready = false;
  public step2Ready = false;
  public batchEditOpen = false;
  public batchEdit: BatchEdit;
  public batchEditImages: number[] = [];
  public errors = false;
  public showingLogs = false;
  public attachments: FileUp[] = [];
  public imageTypes: ImageType[] = [];
  public batchId = 0;
  public batchTypeId: number;
  public batchUploadName = '';
  public batchLogs: IRowModel[] = [];
  public batchLogColumnData: IColumnModel[] = [];
  public progressPercent: number;
  public sourceData: LUSource[] = [];
  public callNumberData: CallNumberModel[] = [];
  public chosenSourceCallNumber: CallNumberModel;

  private imagePosterSubscription: Subscription;
  private imageTypeSubscription: Subscription;
  private nextBatchNoSubscription: Subscription;
  private batchLogsSubscription: Subscription;
  private luSourceSubscription: Subscription;
  private callNumbersSubscription: Subscription;
  private subscriptions: Subscription[] = [];
  private imagePosterCanceler: Subject<void> = new Subject<void>();
  type: any;

  constructor(private imgSvc: ImageService, private imgTypeSvc: LookupDataService, private appInsightsSvc: AppInsightsService, private notiSvc: StarbaseNotificationService) {
    this.chosenSourceCallNumber = new CallNumberModel();
    // modify what columns we show on this instance of the Upload Log Table-Editor component...
    this.batchLogColumnData = [
      new ColumnModel('UID', 'uid', 'UID', false, 'number', false, false, 10, false, null, null, 0),
      new ColumnModel('Batch #', 'batchNo', 'BatchNo', false, 'number', true, false, 10, false, null, null, 9),
      new ColumnModel('Name', 'batchName', 'BatchName', true, 'string', false, false, 150, true, null, null, 14),
      new ColumnModel('Elapsed Time', 'elapsedTime', '', false, 'string', false, false, 100, true, null, null, 12.5),
      new ColumnModel('Files Attempted', 'numberOfFilesSelected', 'NumberOfFilesSelected', false, 'number', false, false, 100, true, null, null, 13.5),
      new ColumnModel('Files Successful', 'numberOfFilesSuccessfullyUploaded', 'NumberOfFilesSuccessfullyUploaded', false, 'number', false, false, 100, true, null, null, 14),
      new ColumnModel('Image Type', 'imageTypeId', 'ImageTypeId', false, 'string', false, false, 100, false, null, null, 14),
      new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, false, 100, false, null, null, 15),
      new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, false, 100, false, null, null, 17)
    ];
  }

  ngOnInit() {
    this.getImageTypeData();
    // this.getBatchNoData();
    this.getLUSourceData();
  }
  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      if (sub) {
        sub.unsubscribe();
      }
    }
    if (this.imagePosterCanceler) {
      this.imagePosterCanceler.complete();
      this.imagePosterCanceler.unsubscribe();
    }
  }
  private getImageTypeData(): void {
    console.log(this.imgTypeSvc.dataGetAllReqCancel$.observers.length);
    this.imageTypeSubscription = this.imgTypeSvc.getAllRequisiteData<ImageType>(this.imgTypeSvc.imageTypesUrl)
      .pipe(finalize(() => console.debug('finished obs of image types')))
      .subscribe(t => {
      this.imageTypes = t;
      // this.batchTypeId = t[0].uid;
      this.batchTypeId = -1;
      this.message = '';
      if (!this.imageTypes.length) {
         throwError('No types loaded');
      }
    }, () => {
      this.errors = true;
      this.message = 'Error when loading the available image types. Please try again later.';
      this.messageBadgeClass = 'badge badge-danger';
    });
    this.subscriptions.push(this.imageTypeSubscription);
  }

  getCallNumberData(sourceId: number): void {
    this.message = LOADING_MESSAGE;
    this.callNumbersSubscription = this.imgTypeSvc.getCallNumberBySourceFromServer(sourceId, true).subscribe(
      d => {
        this.callNumberData = d;
        this.sourceCallNoFilterCmp.resetCallNumberDropdowns();
        this.message = 'Choose call number data';
      },
      () => {
        this.errors = true;
        this.message = 'Error when loading the call number data. Please reload the system.';
        this.messageBadgeClass = 'badge badge-danger';
      });
    this.subscriptions.push(this.callNumbersSubscription);
  }

  // private getBatchNoData(): Subject<number> {
  //   this.message = LOADING_MESSAGE;
  //   const obs = new Subject<number>();
  //   this.nextBatchNoSubscription = this.imgTypeSvc.getNextBatchNoFromServer().subscribe(n => {
  //     this.batchId = n;
  //     obs.next(n);
  //     this.message = 'Choose an image type for this batch.';
  //   }, () => {
  //     this.errors = true;
  //     obs.hasError = true;
  //     obs.error(e => {
  //       this.message = 'Error when loading the next batch number. Please reload the system.';
  //       this.messageClass = 'badge badge-danger';
  //     });
  //   });
  //   return obs;
  // }
  private getLUSourceData(): void {
    this.message = LOADING_MESSAGE;
    this.luSourceSubscription = this.imgTypeSvc.getAllRequisiteData<LUSource>(this.imgTypeSvc.getLUSourcesUrl).subscribe(l => {
      this.sourceData = onlyUniqueByKey(l, 'source');
      this.message = 'Choose image type for this batch.';
    }, () => {
      this.errors = true;
      this.setMessage('Error when loading the Source lookup data. Please reload the system.', false, true);
    });
    this.subscriptions.push(this.luSourceSubscription);
  }

  // loads the log records from the server to display in table-editor (readonly) instance
  private getBatchLogsData(): void {
    this.message = LOADING_MESSAGE;
    this.batchLogsSubscription = this.imgTypeSvc.getAllRequisiteData<BatchLog>(this.imgTypeSvc.getBatchLogUrl).subscribe(d => {
      of(d).pipe(map((e: BatchLog[]) =>
        e.map(k => {
          const elapsedTime = getSecondsElapsedBetweenTwoDates(new Date(k.beganUpload), new Date(k.finishedUpload)) + ' seconds';
          const findImageTypeName = this.imageTypes.find(i => i.uid === k.imageTypeId).typeOfImage;
          return ({
            uid: k.uid, editable: false, editMode: false, batchNo: k.batchNo, batchName: k.batchName, elapsedTime: elapsedTime.toString(), numberOfFilesSelected: k.numberOfFilesSelected, numberOfFilesSuccessfullyUploaded: k.numberOfFilesSuccessfullyUploaded, imageTypeId: findImageTypeName + ' (' + k.imageTypeId + ')', createdByUser: k.createdByUser, createdDateTime: k.createdDateTime
          });
        }
        ))
      ).subscribe(f => this.batchLogs = f);
      this.message = 'Choose image type for this batch.';
    },
      () => {
        this.errors = true;
        this.setMessage('Error loading the upload logs.', false, true);
      });
    this.subscriptions.push(this.batchLogsSubscription);
  }

  /* ---Main file upload method--- */
  handleFileInput(event: any, files: FileList): void {
    if (this.working) {
      return;
    }

    event.preventDefault();
    console.log('File input received.');
    this.errors = false;
    this.queueCount = 0; // reset counter
    this.attachments = [];
    if (files.length < 1) {
      this.setMessage('Select some images and try again', true);
      return;
    }
    if (files.length > this.maxSimultaneousFiles) {
      console.warn('User attempted to upload ' + files.length + ' files at a time.');
      this.setMessage('Please select ' + this.maxSimultaneousFiles + ' or fewer images at a time', true);
      return;
    }

    this.setWorking(true, 'Working...');

    // create the actual Batch Log on the server, so we get the right UID to work with for this session (prevent collision with simultaneous users)
    this.nextBatchNoSubscription = this.createNewBatchLog(this.batchTypeId, files.length, this.batchUploadName).subscribe(
      b => {
        if (!b) {
          this.batchLogError('Received null batch log from server.');
          return;
        }

        this.theLog = b; // set the newly created BatchLog to local var so we have the proper ID
        this.startUploading(files);
      },
      e => {
        this.batchLogError(e);
      }
    );
    this.subscriptions.push(this.nextBatchNoSubscription);
  }

  private batchLogError(e: any) {
    this.message = 'Could not create the Upload Log / Batch # on the server.';
    this.errors = true;
    this.setWorking(false, e.toString(), false, true);
  }

  private startUploading(files: FileList) { // prep work
    for (let i = 0; i < files.length; i++) {
      const f: FileUp = new FileUp(files.item(i));
      f.status = FILE_WAITING;
      this.attachments.push(f); // gather all files into the working array
    }
    this.progressPercent = 1;
    this.queueCount = this.attachments.length;
    this.theLog.beganUpload = GetTimezoneCorrectedDate(); // Set the log's begin-time because we are about to start uploading
    // for (const f of this.attachments) {
      // if (f.status === 'Canceled.') {
      //   this.finishProcessing(this.theLog);
      //   this.imagePosterCanceler.next();
      //   this.imagePosterCanceler.complete();
      //   return;
      // }
    // }
    this.loopUploadFiles();
  }

  private loopUploadFiles() {
    const fileGo = this.attachments[this.queueCount - 1];
    if (fileGo === undefined) {
      this.errors = true;
      console.error('Unexpected end of attachments array');
      this.finishProcessing(this.theLog);
      return;
    }
    if (fileGo.status === FILE_CANCELED) {
      this.finishProcessing(this.theLog);
      this.imagePosterCanceler.next();
      this.imagePosterCanceler.complete();
      return;
    }
    if (fileGo.file.size > this.maxFileSize) {
      fileGo.status = FILE_ERROR + ' File exceeds filesize limit and will not be uploaded.';
      this.errors = true;
      this.queueCount--; // decrement items in the queue to trigger finish time
      if (this.queueCount < 1) {
        this.finishProcessing(this.theLog);
      } else {
        this.loopUploadFiles();
      }
    }
    if (fileGo.file.name.length > 100) {
      fileGo.status = FILE_ERROR +  ' File name exceeds 100 characters and will not be uploaded.';
      this.errors = true;
      this.queueCount--;
      if (this.queueCount < 1) {
        this.finishProcessing(this.theLog);
      } else {
        this.loopUploadFiles();
      }
    }

    fileGo.status = FILE_UPLOADING;
    /* upload the image file with the batch log UID for this session
      and also source info and imgType */
    this.imagePosterSubscription = this.imgSvc.postImageToServer(
      fileGo.file,
      this.batchTypeId,
      this.theLog.uid,
      this.chosenSourceCallNumber.uid,
      this.chosenSourceCallNumber.lU_SourceUID,
      this.imagePosterCanceler).subscribe(
      (img) => {
        fileGo.status = FILE_DONE;
        this.theLog.numberOfFilesSuccessfullyUploaded++;
        this.progressPercent = this.recalcProgress(); // update progress bar visual
        this.queueCount--;
        if (this.batchEdit) {
          this.batchEditImages.push(img.uid);
        }
        if (this.queueCount < 1) {
          this.finishProcessing(this.theLog);
        } else {
          this.loopUploadFiles();
        }
      }, err => {
        this.errors = true;
        this.setWorking(true, 'Still working... Some files did not upload successfully.');
        try {
          fileGo.status = FILE_ERROR + ' ' + err['serverMsg'][0];
        } catch {
          console.error(err);
          fileGo.status = FILE_ERROR + ' Unknown';
          this.appInsightsSvc.logError(err); // send the failure info to Azure App Insights for debugging
        }
        this.progressPercent = this.recalcProgress();
        this.queueCount--;
        if (this.queueCount < 1) {
          this.finishProcessing(this.theLog);
        } else {
          this.loopUploadFiles();
        }
      });
    this.subscriptions.push(this.imagePosterSubscription);
  }

  readSourceCallEmitted(data: CallNumberModel[]): void {
    this.chosenSourceCallNumber = data[0];
    if (this.chosenSourceCallNumber) {
      this.step2Ready = true;
      this.message = 'Ready';
    } else {
      this.step2Ready = false;
      this.message = 'Choose call number data';
    }
  }

  public changedBatchType(e: string) {
    // eslint-disable-next-line eqeqeq
    if (+e != -1) {
      this.step1Ready = true;
      this.message = '';
    } else {
      this.step1Ready = false;
    }
    this.type = this.imageTypes.find(i => i.uid === +e.substr(3)).typeOfImage;
    this.cardTitle = this.defaultCardTitle + this.type || 'Images';
  }
  public changedSourceSelection(e: LUSource) {
    this.step2Ready = false;
    this.message = 'Choose call number data';

    if (e === null || e === undefined) {
      this.chosenSourceCallNumber = null;
      return;
    }

    if (!this.chosenSourceCallNumber) {
      this.chosenSourceCallNumber = new CallNumberModel();
    }

    this.chosenSourceCallNumber.lU_Source = e;
    this.chosenSourceCallNumber.lU_SourceUID = e.uid;
    this.getCallNumberData(this.chosenSourceCallNumber.lU_SourceUID);
  }

  public closeCard(): void {
    this.clear();
    this.showCard = false;
    this.cardClosed.emit();
  }

  public clear(): void {
    this.attachments = [];
    this.errors = false;
    this.setWorking(false, '', false, false);
  }

  public showBatchLogs(): void {
    this.getBatchLogsData();
    this.showingLogs = !this.showingLogs;
  }

  public cancelJob(): void {
    console.warn('Canceling upload job!');
    this.queueCount = 0;
    this.attachments.forEach(a => {
      if (a.status === FILE_UPLOADING || a.status === FILE_WAITING) {
        a.status = FILE_CANCELED;
      }
    });
    this.finishProcessing(this.theLog);
    this.imagePosterCanceler.next();
    this.imagePosterCanceler.complete();
    this.setMessage('Canceled upload job.', true);
    this.progressPercent = 100;
  }

  private recalcProgress(): number {
    let done = 0;
    this.attachments.forEach(a => {
      if (a.status === FILE_DONE || a.status.indexOf(FILE_ERROR) > -1) {
        done++;
      }
    });
    const factor = 100 / this.attachments.length;
    return factor * done;
  }

  private finishProcessing(log: BatchLog): void {
    console.log("finishProcessing: ", log);
    log.finishedUpload = GetTimezoneCorrectedDate(); // set finished datetime stamp
    this.nextBatchNoSubscription = this.editBatchLog(log).subscribe(
      () => {
        console.log("editBatchLog completed");
        if (!this.errors) {
          this.setWorking(false, 'Ready');
        } else {
          this.setWorking(false, 'Done, but some files did not upload successfully. Press Clear to try again.');
        }
      },
      e => {
        this.errors = true;
        console.error('Upload log did not save to server. ' + e['friendly']);
        this.setWorking(false, 'Process finished, but the upload logging did not record properly.', false, true);
      },
      () => this.triggerRefresh()
    );

    if (this.batchEditImages && this.batchEditImages.length > 0 && !this.isSaving) {
      this.batchEdit.imageModelUIDs = this.batchEditImages;
      this.isSaving = true;
      console.log("starting batchEditImageRecordsOnServer: ", this.batchEdit);

      const batchedit$ = this.imgSvc.batchEditImageRecordsOnServer(this.batchEdit).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Saving...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        batchedit$);
      batchedit$.subscribe({
          next: () => {
            console.log("success with editing batch edit");
            this.notiSvc.postNotification(new StarbaseNotificationObject('Batch Edit Successful', this.batchEdit.imageModelUIDs.length + ' Image Records Edited', StarbaseNotificationSentiment.Success, 5));
            this.batchEditImages = [];
            this.isSaving = false;
            notifier.updateTitle('Success');
            notifier.updateContent('Batch Edit Success Fully Applied');
          },
          error: (error) => {
            this.notiSvc.postNotification(new StarbaseNotificationObject('Batch Edit Failed', 'Failed to Edit ' + this.batchEdit.imageModelUIDs.length + ' Records', StarbaseNotificationSentiment.Error, 5));
            console.error(error);
            this.isSaving = false;
            notifier.updateTitle('Error');
            notifier.updateContent('Failed to Apply Batch Edit');
          }
        });
        this.notiSvc.postNotification(notifier);
    }

    this.imgSvc.clearFilterCache(); // force refresh of this data to accommodate new records
  }
  private triggerRefresh(): void {
    this.refreshTrigger.emit(1);
  }
  // to be called when the upload iteration is done to report final status
  private editBatchLog(log: BatchLog): Observable<any> {
    return this.imgTypeSvc.putRequisiteData<BatchLog>(this.imgTypeSvc.putBatchLogUrl, log.uid.toString(), log);
  }
  // to be called when user is ready to start uploading and should complete successfully before allowing any files to upload.
  private createNewBatchLog(imageTypeId: number, numberOfFiles: number, name: string = ''): Observable<BatchLog> {
    const startBatchLog = new BatchLog(numberOfFiles, imageTypeId, name);
    return this.imgTypeSvc.postRequisiteData(this.imgTypeSvc.postBatchLogObjectUrl, startBatchLog);
  }
  private setWorking(set: boolean, msg: string = '', warnings: boolean = false, errors: boolean = false) {
    this.working = set;
    this.setMessage(msg, warnings, errors);
  }
  private setMessage(msg: string = '', warnings: boolean = false, errors: boolean = false): void {
    this.message = msg;
    if (warnings) {
      this.messageBadgeClass = 'badge badge-warning';
      this.messageIconClass = 'fa-exclamation-triangle';
    } else if (errors) {
      this.messageBadgeClass = 'badge badge-danger';
      this.messageIconClass = 'fa-exclamation-circle';
    } else {
      this.messageIconClass = 'fa-info-circle text-info';
      this.messageBadgeClass = '';
    }
  }

  getImageType() {
    return this.imageTypes.filter(it => it.uid === this.batchTypeId)[0];
  }

  toggleBatchEdit() {
    this.batchEditOpen = !this.batchEditOpen;
  }

  closeBatchEdit() {
    this.batchEditOpen = false;
  }

  batchEditConfirmed(edit: BatchEdit) {
    this.batchEditOpen = false;
    this.batchEdit = edit;
    console.log(edit);
  }
}
